<template>
  <StandardCardPageContainer>
    <div v-if="showTrustGroupSearch">
      <v-row>
        <v-col>
          <h1 class="mb-8">Find Trust Group</h1>
        </v-col>
      </v-row>
      <TrustGroupSearch
        :secondary-button-text="'Back'"
        @found-trust-group="
          trustGroup = $event;
          showTrustGroupSearch = false;
        "
        @secondary-button-clicked="router.push(RouterPath.AdministratorPage)"
      />
    </div>
    <TrustGroupDisplay
      v-if="!showTrustGroupSearch && trustGroup != undefined"
      :trust-group="trustGroup"
      @exit="showTrustGroupSearch = true"
    />
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import { ref, type Ref } from "vue";
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import TrustGroupDisplay from "@/views/admin-view/TrustGroupDisplay.vue";
import TrustGroupSearch from "@/views/admin-view/TrustGroupSearch.vue";
import { TrustGroup } from "@/models/trustGroup";

import { RouterPath } from "@/models/enum/routerPath";
import { useRouter } from "vue-router";

const trustGroup: Ref<TrustGroup | undefined> = ref(new TrustGroup());
const showTrustGroupSearch = ref(true);
const router = useRouter();
</script>
